import { ErrorWidgetAttr } from "@swiggy-private/core-ui";

export const ERROR_WIDGET_ATTR: Record<string, ErrorWidgetAttr> = {
    ITEM_OUTOFSTOCK: {
        title: "{0} Item(s) unavailable",
        message: "Sorry, few items are out of stock.",
        cta: "Remove Unavailable Items",
        icon: "item-unavilable_xcim1r",
    },
    ALL_ITEMS_OOS: {
        title: "None of the items are available",
        message: "Please clear cart and add other items",
        cta: "Clear Cart",
        icon: "item-unavilable_xcim1r",
    },
    MIN_ITEM_BREACH: {
        title: "Minimum item breach",
        message: "Please add more items to the cart",
        cta: "Remove deal",
        secondaryCtaText: "Keep deal",
        icon: "item-unavilable_xcim1r",
        headerIcon: "warningFilled20",
    },
    MAX_INVENTORY_BREACH: {
        title: "Maximum inventory breach",
        message: "Please remove some items from the cart",
        cta: "Refresh",
        icon: "item-unavilable_xcim1r",
        headerIcon: "warningFilled20",
    },
    TABLE_RESERVATION_CHECKED_IN: {
        title: "Advance booking required",
        message: "This pre-book deal is for reservations made before your visit. Please select a later time or date.",
        cta: "Go Back",
        icon: "cart_error_icon_ymvz3v",
        headerIcon: "warningFilled20",
        showOverlay: true,
    },
    DEFAULT: {
        title: "Our systems are acting up",
        message: "Whoops! Something went wrong. Please check later",
        cta: "Clear Cart",
        icon: "cart_error_icon_ymvz3v",
    },
};

export enum CART_STATUS_CODES {
    SUCCESS = 0,
    FAILURE = 1,
    ITEM_OUTOFSTOCK = 104,
    ALL_ITEMS_OOS = 105,
    MIN_ITEM_BREACH = 106,
    MAX_INVENTORY_BREACH = 107,
    TABLE_RESERVATION_CHECKED_IN = 140,
}
